import ApplicationConfig from '../application-config'
import UTCDateTime from '../utc-datetime'
import connectHttpBase from './connect-http-base'

const PATH_FIELD_ITEMS = '/v1/field_items'
const PATH_THUMBNAILS = '/v1/thumbnails'
const PATH_TASK_RECORD_ITEMS = '/v1/task_record_items'
const PATH_REFLINE_ITEMS = '/v1/ref_line_items'

const V2_PATH_FIELD_ITEMS = '/v2/field_items'
const V2_PATH_TASK_RECORD_ITEMS = '/v2/task_record_items'
const V2_PATH_OPERATIONS = '/v2/operations'
const V2_PATH_REALTIME = '/v2/realtime'
const V2_PATH_REFLINE_ITEMS = '/v2/ref_line_items'

const V1_PATH_IMPORT = '/v1/import'

const V2_PATH_PLANTINGS = '/v2/plantings'

const V2_PATH_OBSERVATIONS = '/v2/observations'


/** @deprecated */
const V2_PATH_PRODCUTS = '/v2/products'

const V1_MIGRATION = '/v1/migration'

/**
 * FireTest
 */
const V1_FIRE_TEST = '/v1/firetest'

/**
 * ConnectNaviClient
 */
class ConnectNaviClient {
  getTsvArchiveEndpoint(filterName, pageIndex, pageSize) {
    const path =
      V2_PATH_TASK_RECORD_ITEMS + '/archives/tsv/' + filterName + '?page=' + pageIndex + '&pageSize=' + pageSize
    return this.naviEndpoint(path)
  }

  saveTaskFilter(taskFilter) {
    const path = V2_PATH_TASK_RECORD_ITEMS + '/filters'
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().post(endPoint, taskFilter)
  }

  countTasksForField(field) {
    const path = V2_PATH_FIELD_ITEMS + '/' + field.geoInfoKey + '/tasks/count'
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }

  deleteField(field) {
    const path = PATH_FIELD_ITEMS + '/' + field.geoInfoKey + '/delete?deleteTsv=true'
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().put(endPoint)
  }

  importFields(importFieldsRequest) {
    const path = V2_PATH_FIELD_ITEMS + ''
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().post(endPoint, importFieldsRequest)
  }

  uploadGeoFile(file, params) {
    const path = V1_PATH_IMPORT + '/geo_json'
    const endPoint = this.naviEndpoint(path)
    let form = new FormData()
    form.append('file', file)
    form.append('encoding', params.encoding)
    return connectHttpBase.getAuthenticatedHttpClient().post(endPoint, form, {
      headers: {
        'Content-Type': 'multipart-formdata',
      },
    })
  }

  listOperationAvailableTypes() {
    const path = V2_PATH_OPERATIONS + '/available/types'
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getHttpClient().get(endPoint)
  }

  /** @deprecated */
  createProduct(editProductRequest) {
    const path = V2_PATH_PRODCUTS
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().post(endPoint, editProductRequest)
  }

  /** @deprecated */
  updateProduct(id, editProductRequest) {
    const path = V2_PATH_PRODCUTS + '/' + id
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().put(endPoint, editProductRequest)
  }

  /** @deprecated */
  deleteProduct(product) {
    const path = V2_PATH_PRODCUTS + '/' + product.id
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().delete(endPoint)
  }

  /** @deprecated */
  listProducts() {
    const path = V2_PATH_PRODCUTS
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }

  updateFieldMetaData(updateRequest) {
    const field = updateRequest.field
    let path = V2_PATH_FIELD_ITEMS + '/' + field.geoInfoKey + '/'
    path = path + encodeURIComponent(field.lastModifiedDateTime) + '/meta'
    const endPoint = this.naviEndpoint(path)
    const request = {
      name: updateRequest.name,
      caption: updateRequest.caption,
      metaDataUpdatedAt: UTCDateTime.utcStringNow(),
    }
    return connectHttpBase.getAuthenticatedHttpClient().put(endPoint, request)
  }

  updateFieldPolygon(updateRequest) {
    const field = updateRequest.field
    let path = V2_PATH_FIELD_ITEMS + '/' + field.geoInfoKey + '/'
    path = path + encodeURIComponent(field.lastModifiedDateTime) + '/polygon'
    const endPoint = this.naviEndpoint(path)
    const request = {
      features: updateRequest.features,
    }
    return connectHttpBase.getAuthenticatedHttpClient().put(endPoint, request)
  }

  updateTaskMetaData(updateRequest) {
    const task = updateRequest.task
    let path = V2_PATH_TASK_RECORD_ITEMS + '/' + task.geoInfoKey + '/'
    path = path + encodeURIComponent(task.lastModifiedDateTime) + '/meta'
    const endPoint = this.naviEndpoint(path)
    const request = {
      name: updateRequest.name,
      caption: updateRequest.caption,
      metaDatas: updateRequest.metaDatas,
      metaDataUpdatedAt: UTCDateTime.utcStringNow(),
    }
    return connectHttpBase.getAuthenticatedHttpClient().put(endPoint, request)
  }

  /**
   * @deprecated
   * 利用しないでください。GeoJsonはgetTaskInfoを利用してください
   */
  getTaskGeoJson2(task) {
    let path = V2_PATH_TASK_RECORD_ITEMS + '/' + task.geoInfoKey + '/'
    path = path + encodeURIComponent(task.lastModifiedDateTime) + '/geo.json'
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }

  getTaskInfo(task) {
    let path = V2_PATH_TASK_RECORD_ITEMS + '/' + task.geoInfoKey + '/'
    path = path + encodeURIComponent(task.lastModifiedDateTime) + '/info'
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }

  /**
   *  @deprecated
   * 利用しないでください。天候情報はGrowサーバーを利用します
   */
  getCurrentTaskWeatherInfo(task) {
    let path = V2_PATH_TASK_RECORD_ITEMS + '/' + task.geoInfoKey + '/'
    path = path + encodeURIComponent(task.lastModifiedDateTime) + '/weather'
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }

  getTasksInField2(field, page) {
    let path = V2_PATH_FIELD_ITEMS + '/' + field.geoInfoKey + '/'
    path += encodeURIComponent(field.lastModifiedDateTime) + '/tasks'
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint, {
      params: {
        page: page.page,
        pageSize: page.pageSize,
      },
    })
  }

  getFields2() {
    const endPoint = this.naviEndpoint(V2_PATH_FIELD_ITEMS)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint, {
      params: {
        listMode: 'ExcludeDeleteFlaged',
        includeGeoJson: true,
      },
    })
  }

  getFields2ForPage(params) {
    const endPoint = this.naviEndpoint(V2_PATH_FIELD_ITEMS + '/page')
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint, {
      params: {
        listMode: 'ExcludeDeleteFlaged',
        page: params.pageOptions.page,
        pageSize: params.pageOptions.pageSize,
        includeGeoJson: true,
        sortKey: params.sortOptions.key,
        sortDirection: params.sortOptions.direction,
      },
    })
  }

  getTasksWithFilter(filter, page) {
    const endPoint = this.naviEndpoint(V2_PATH_TASK_RECORD_ITEMS) + '?page=' + page.page + '&pageSize=' + page.pageSize
    return connectHttpBase.getAuthenticatedHttpClient().post(endPoint, filter)
  }

  getAllTasksBetween(fromMoment, toMoment, listingUser) {
    const endPoint = this.naviEndpoint(V2_PATH_TASK_RECORD_ITEMS) + '/all'
    const from = UTCDateTime.utcStringFromMomentObject(fromMoment)
    const to = UTCDateTime.utcStringFromMomentObject(toMoment)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint, {
      params: {
        from,
        to,
        listingUser,
      },
    })
  }

  getTasks2(page) {
    const endPoint = this.naviEndpoint(V2_PATH_TASK_RECORD_ITEMS)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint, {
      params: {
        listMode: 'ExcludeDeleteFlaged',
        page: page.page,
        pageSize: page.pageSize,
        listingUser: page.listingUser,
      },
    })
  }

  getFields() {
    const endPoint = this.naviEndpoint(PATH_FIELD_ITEMS)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint, {
      params: {
        listMode: 'ExcludeDeleteFlaged',
        includeGeoJson: true,
      },
    })
  }

  getFieldGeoJson(field) {
    const endPoint = this.naviEndpoint(PATH_FIELD_ITEMS) + '/' + field.geoInfoKey + '/geo.json'
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint, {
      params: {
        lastModifiedDateTime: field.lastModifiedDateTime,
      },
    })
  }

  naviEndpoint(path) {
// TEMP     console.log('call navi server. @' + path)
    return ApplicationConfig.getNaviServer() + path
  }

  getTasks() {
    const endPoint = this.naviEndpoint(PATH_TASK_RECORD_ITEMS)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint, {
      params: {
        listMode: 'ExcludeDeleteFlaged',
      },
    })
  }

  getTaskGeoJson(task) {
    const endPoint = this.naviEndpoint(PATH_TASK_RECORD_ITEMS + '/' + task.geoInfoKey + '/geo.json')
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint, {
      params: {
        lastModifiedDateTime: task.lastModifiedDateTime,
        geometoryType: 'LineString',
      },
    })
  }

  getTaskRecordItem(params) {
    const endPoint = this.naviEndpoint(PATH_TASK_RECORD_ITEMS + '/' + params.key)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint, {
      params: {
        lastModifiedDateTime: params.lastModifiedDateTime,
      },
    })
  }

  // @deprecated
  getTaskGeoJsonsInField(field, start, end) {
    const endPoint = this.naviEndpoint(PATH_FIELD_ITEMS + '/' + field.geoInfoKey + '/tasks/geo.json')
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint, {
      params: {
        taskStart: start,
        taskEnd: end,
      },
    })
  }

  getTasksInField(field, start, end) {
    const endPoint = this.naviEndpoint(PATH_FIELD_ITEMS + '/' + field.geoInfoKey + '/tasks')
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint, {
      params: {
        taskStart: start,
        taskEnd: end,
      },
    })
  }

  getRealtimeInfos(username, deviceId, trackKey) {
    const endPoint = this.naviEndpoint(V2_PATH_REALTIME + '/' + username + '/' + deviceId + '/' + trackKey)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }

  getFieldThumbnail(field, geoJsonArg, viewPort, thumbnailSize) {
    const zoom = viewPort.zoom - 1
    const lon = viewPort.center[0]
    const lat = viewPort.center[1]
    const width = thumbnailSize
    const height = thumbnailSize

    // /v1/thumbnails/field_item/{userName}/{geoInfoKey}/{geoJson}/image.jpg?
    // lastModifiedDateTime={lastModifiedDateTime}&lon={lon}&lat={lat}&zoom={zoom}&width={width}&height={height}
    const path =
      PATH_THUMBNAILS +
      '/field_item/' +
      field.username +
      '/' +
      field.geoInfoKey +
      '/' +
      geoJsonArg +
      '/image.jpg?' +
      'lastModifiedDateTime=' +
      field.lastModifiedDateTime +
      '&lon=' +
      lon +
      '&lat=' +
      lat +
      '&zoom=' +
      zoom +
      '&width=' +
      width +
      '&height=' +
      height
    return this.naviEndpoint(path)
  }

  listRefLines(page) {
    const path = V2_PATH_REFLINE_ITEMS
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint, {
      params: {
        page: page.page,
        pageSize: page.pageSize,
      },
    })
  }

  getRefLinesTsvArchiveEndpoint(pageIndex, pageSize) {
    const path = V2_PATH_REFLINE_ITEMS + '/archives/tsv?page=' + pageIndex + '&pageSize=' + pageSize
    return this.naviEndpoint(path)
  }

  importRefLines(request) {
    const path = V2_PATH_REFLINE_ITEMS
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().post(endPoint, request)
  }

  getRefLineGeoJson(refLine) {
    const endPoint = this.naviEndpoint(
      V2_PATH_REFLINE_ITEMS +
        '/' +
        refLine.username +
        '/' +
        refLine.geoInfoKey +
        '/' +
        refLine.lastModifiedDateTime +
        '/geo.json'
    )
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }

  updateRefLineMetaData(updateRequest) {
    const refLine = updateRequest.refLine
    let path = V2_PATH_REFLINE_ITEMS + '/' + refLine.geoInfoKey + '/'
    path = path + encodeURIComponent(refLine.lastModifiedDateTime) + '/meta'
    const endPoint = this.naviEndpoint(path)
    const request = {
      name: updateRequest.name,
      caption: updateRequest.caption,
      metaDataUpdatedAt: UTCDateTime.utcStringNow(),
    }
    return connectHttpBase.getAuthenticatedHttpClient().put(endPoint, request)
  }

  deleteRefLine(refLine) {
    const path = PATH_REFLINE_ITEMS + '/' + refLine.geoInfoKey + '/delete?deleteTsv=true'
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().put(endPoint)
  }

  listPlantings() {
    const endPoint = this.naviEndpoint(V2_PATH_PLANTINGS)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }

  listPlantingsByFieldAndDate(field, date) {
    const endPoint = this.naviEndpoint(V2_PATH_PLANTINGS) + '?fieldPk=' + field.pk + '&date=' + date
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }

  createPlanting(request) {
    const path = V2_PATH_PLANTINGS
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().post(endPoint, request.planting)
  }

  updatePlanting(request) {
    const path = V2_PATH_PLANTINGS + '/' + request.id
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().put(endPoint, request.planting)
  }

  deletePlanting(request) {
    const path = V2_PATH_PLANTINGS + '/' + request.id
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().delete(endPoint)
  }

  getCentroidOfUserFields() {
    const path = V2_PATH_FIELD_ITEMS + '/centroid'
    const endPoint = this.naviEndpoint(path)
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }
  deleteTaskRecordItem(geoInfoKey) {
    const endPoint = this.naviEndpoint(PATH_TASK_RECORD_ITEMS + '/' + geoInfoKey + '/delete')
    return connectHttpBase.getAuthenticatedHttpClient().put(endPoint)
  }

  listPfObservations() {
    const endPoint = this.naviEndpoint(V2_PATH_OBSERVATIONS + '/pf')
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }
  createPfObservation(request) {
    const endPoint = this.naviEndpoint(V2_PATH_OBSERVATIONS + '/pf')
    return connectHttpBase.getAuthenticatedHttpClient().post(endPoint, request.observation)
  }
  updatePfObservation(request) {
    const endPoint = this.naviEndpoint(V2_PATH_OBSERVATIONS + '/pf/' + request.id)
    return connectHttpBase.getAuthenticatedHttpClient().put(endPoint, request.observation)
  }
  deletePfObservation(request) {
    const endPoint = this.naviEndpoint(V2_PATH_OBSERVATIONS + '/pf/' + request.id)
    return connectHttpBase.getAuthenticatedHttpClient().delete(endPoint)
  }

  listAtObservations() {
    const endPoint = this.naviEndpoint(V2_PATH_OBSERVATIONS + '/at')
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }
  createAtObservation(request) {
    const endPoint = this.naviEndpoint(V2_PATH_OBSERVATIONS + '/at')
    return connectHttpBase.getAuthenticatedHttpClient().post(endPoint, request.observation)
  }
  updateAtObservation(request) {
    const endPoint = this.naviEndpoint(V2_PATH_OBSERVATIONS + '/at/' + request.id)
    return connectHttpBase.getAuthenticatedHttpClient().put(endPoint, request.observation)
  }
  deleteAtObservation(request) {
    const endPoint = this.naviEndpoint(V2_PATH_OBSERVATIONS + '/at/' + request.id)
    return connectHttpBase.getAuthenticatedHttpClient().delete(endPoint)
  }

  createFieldElevationMap(params) {
    let endPoint = this.naviEndpoint(V2_PATH_FIELD_ITEMS + '/' + params.field.id + '/elevation')
    let request = {
      meshSize: params.meshSize,
      maxPointCount: params.maxPointCount,
      taskFetchLimit: params.taskFetchLimit,
      gnssStatusFilter: params.gnssStatusFilter,
    }
    if (params.zRange) {
      const zRange = params.zRange
      request['zMin'] = zRange.min
      request['zMax'] = zRange.max
    }
    return connectHttpBase.getAuthenticatedHttpClient().post(endPoint, request)
  }

  getFieldElevationMap(field) {
    const endPoint = this.naviEndpoint(V2_PATH_FIELD_ITEMS + '/' + field.id + '/elevation')
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }

  migrationTestData(username, apiKey) {
    let endPoint = this.naviEndpoint(V1_FIRE_TEST) + '/compare/testdata'
    endPoint += '?firetest-compare=' + apiKey
    endPoint += '&username=' + username
    return endPoint
  }

  getCompareEndpoint(username, apiKey) {
    let endPoint = this.naviEndpoint(V1_FIRE_TEST) + '/compare'
    endPoint += '?firetest-compare=' + apiKey
    endPoint += '&username=' + username
    return endPoint
  }
  migrationTestCompare(username, apiKey) {
    let endPoint = this.naviEndpoint(V1_FIRE_TEST) + '/compare'
    endPoint += '?firetest-compare=' + apiKey
    endPoint += '&username=' + username
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }

  getMigrationPastCompare(apiKey) {
    let endPoint = this.naviEndpoint(V1_FIRE_TEST) + '/compare/results'
    endPoint += '?firetest-compare=' + apiKey
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }

  migration(request) {
    const endPoint = this.naviEndpoint(V1_MIGRATION + '/firestore')
    return connectHttpBase.getAuthenticatedHttpClient().post(endPoint, request)
  }

  dataCopyCount(request) {
    let endPoint = this.naviEndpoint(V1_FIRE_TEST) + '/datacopy/count'
    endPoint += '?firetest-data=' + request.apiKey
    endPoint += '&username=' + request.username
    endPoint += '&env=' + request.env
    return connectHttpBase.getAuthenticatedHttpClient().get(endPoint)
  }
  dataCopyDestroy(request) {
    let endPoint = this.naviEndpoint(V1_FIRE_TEST) + '/datacopy/destroy'
    endPoint += '?firetest-data=' + request.apiKey
    endPoint += '&username=' + request.username
    endPoint += '&env=' + request.env
    return connectHttpBase.getAuthenticatedHttpClient().delete(endPoint)
  }
  dataCopy(request, apiKey) {
    let endPoint = this.naviEndpoint(V1_FIRE_TEST) + '/datacopy'
    endPoint += '?firetest-data=' + apiKey
    return connectHttpBase.getAuthenticatedHttpClient().post(endPoint, request)
  }
  validateGeoData(request, apiKey) {
    let endPoint = this.naviEndpoint(V1_FIRE_TEST) + '/validation/geo_data'
    endPoint += '?firetest-data=' + apiKey
    endPoint += '&username=' + request.username
    return endPoint
  }
}

const connectNaviClient = new ConnectNaviClient()
export default connectNaviClient
